import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function About() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://nin.res.in/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li><a href="#notice">Events</a></li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* About Content */}
      <div className="about-page">
        <div className="about-hero">
          <h1 className="about-main-heading">About NRB</h1>
          <p className="about-subtitle">Naturopathy Registration Board - Promoting Natural Healthcare Excellence</p>
        </div>

        <div className="about-content">
          <div className="about-card">
            <h2>Welcome to Naturopathy Registration Board</h2>
            <p>
              The Naturopathy Registration Board (NRB) is a premier organization constituted by the Ministry of Ayush, Government of India, 
              operating under the aegis of the National Institute of Naturopathy, Pune. Our mission is to provide a structured framework for 
              the registration and regulation of naturopathy practitioners and institutions across India.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Vision</h2>
            <p>
              To establish naturopathy as a recognized and credible system of healthcare by ensuring professional standards, 
              quality assurance, and ethical practice among naturopathy practitioners and institutions.
            </p>
          </div>

          <div className="about-section">
          
            <h2>Our Mission</h2>
            <ul className="about-list">
              <li>To provide central registration to qualified BNYS (Bachelor of Naturopathy and Yogic Sciences) graduates</li>
              <li>To register and recognize Para-Medical professionals in the field of naturopathy</li>
              <li>To accredit naturopathy institutions and hospitals maintaining quality standards</li>
              <li>To ensure professional ethics and practice standards in naturopathy</li>
              <li>To promote research and development in naturopathy</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>What We Offer</h2>
            <div className="about-grid">
              <div className="about-item">
                <h3>🔐 Central Registration</h3>
                <p>Comprehensive registration system for BNYS graduates</p>
              </div>
              <div className="about-item">
                <h3>✓ Accreditation</h3>
                <p>Quality assurance for naturopathy institutions</p>
              </div>
              <div className="about-item">
                <h3>📋 Verification</h3>
                <p>Credential verification and professional standards</p>
              </div>
              <div className="about-item">
                <h3>🎓 Support</h3>
                <p>Continuous guidance for practitioners and institutions</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;

